import { getActiveLocale } from "../i18n/i18n";

/**
 * Formats a price for display (e.g. 24.1 → "$24.10", 1200.5 → "$1,200.50").
 *
 * Every customer-facing price goes through here rather than raw `${amount}`
 * interpolation: JS number-to-string drops trailing zeros (`24.1`), omits the
 * thousands separator, and passes float noise straight through (`51.999`).
 *
 * The CURRENCY comes from the facility, never the visitor: callers pass the
 * ISO 4217 `currencyCode` carried on the payload the price came from
 * (unit-picker, reservation draft, lease summary), which the server resolved
 * from the location's Cortex Currency Code variable (org → location cascade).
 * Payloads from before that field existed omit it and render as USD — which
 * is what they were.
 *
 * The LOCALE only controls formatting conventions — separator + symbol
 * position — so a fr-CA visitor at a CAD facility sees "59,50 $ CA" while an
 * en-US visitor sees "CA$59.50". Same amount, same currency, either way.
 */
export function formatCurrency(amount: number, currencyCode?: string, opts?: { maximumFractionDigits?: number }): string {
  // A malformed code makes Intl.NumberFormat throw a RangeError; a bad
  // operator value must degrade to USD formatting, never crash the card.
  try {
    return new Intl.NumberFormat(getActiveLocale(), { style: "currency", currency: currencyCode || "USD", ...opts }).format(amount);
  } catch {
    return new Intl.NumberFormat(getActiveLocale(), { style: "currency", currency: "USD", ...opts }).format(amount);
  }
}
